import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { HttpClientModule } from '@angular/common/http';
import { NgxPaginationModule } from 'ngx-pagination';
import { LoadingComponent } from '../shared/loading.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TransPipe } from './trans.pipe';
import { PrintTransPipe } from './print-trans.pipe';
import { PermissionModule } from './permission-module/module/ng2-permission.module';
import { DatepickerRangeComponent } from './datepicker-range/datepicker-range.component';
import { FindFlightComponent } from './find-flight/find-flight.component';
import {Nl2BrPipeModule} from "nl2br-pipe";

@NgModule({
  imports: [
    NgbModule.forRoot(),
    PermissionModule.forRoot(),
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFontAwesomeModule,
    HttpClientModule,
    NgxPaginationModule,
    Nl2BrPipeModule
  ],
  exports: [
    NgbModule,
    PermissionModule,
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFontAwesomeModule,
    HttpClientModule,
    NgxPaginationModule,
    LoadingComponent,
    TransPipe,
    PrintTransPipe,
    DatepickerRangeComponent,
    FindFlightComponent,
    Nl2BrPipeModule
  ],
  declarations: [
    LoadingComponent,
    TransPipe,
    PrintTransPipe,
    DatepickerRangeComponent,
    FindFlightComponent
  ],
  providers: [TransPipe]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts